import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import ServicePageCta from "../ui/ServicePageCta";
import { PrimaryLink } from "../ui/Buttons";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import Diff from "../../assets/Differential.png";

const DifferentialService = () => {
  return (
    <>
      <SeoHead
        title="Differential Service in Temecula | Advanced Automotive Smog"
        description="Differential fluid service and repair in Temecula to reduce friction, prevent wear, and protect your vehicle's drivetrain over the long term."
        path="/services/diff-service"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Differential Service"
          path="/services/diff-service"
          description="Differential fluid service and repair in Temecula to reduce friction, prevent wear, and protect your vehicle's drivetrain."
          serviceType="Differential service"
        />

        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">

          {/* Image - Mobile priority */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={Diff}
                alt="Differential service"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text content */}
          <div className="w-full md:w-1/2">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Drivetrain Care
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-900 mb-3">
              Differential Service
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              Your differential keeps the wheels spinning smoothly and evenly.
              Over time, fluid breaks down and components can wear, making
              service essential for long-term drivetrain health.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What Is Differential Service?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              The differential allows your wheels to rotate at different speeds,
              especially during turns. Maintaining clean differential fluid helps
              reduce friction, prevent wear, and extend the life of internal
              gears and bearings.
              <br />
              <br />
              Our service includes fluid replacement, inspection, and premium
              lubricant refills to keep everything running smoothly.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Differential fluid inspection and replacement</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Full assessment of internal gears and seals</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Reduces wear and increases drivetrain longevity</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Works with all makes, models, and drivetrain types</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Professional service with premium lubricants</span>
              </li>
            </ul>

            {/* Clean centered button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>

          </div>
        </div>
            <ServicePageCta />
      </ServicePageShell>
    </>
  );
};

export default DifferentialService;


